export const getForumData = state => state.forumData;
export const getCommunityId = state => getForumData(state).communityId;
export const getForumTitle = state => getForumData(state).label;



// WEBPACK FOOTER //
// ./app/selectors/forum-data-selectors.js